import TruckReports from './tables/safety/trucks';

const SafetyBriefing = () => {

    return (
        <>
            <div className="main-container">
                <TruckReports />
                <hr />
            </div>
        </>
    );
};

export default SafetyBriefing;
